import { useEffect } from 'react'
import { useAuthMode } from '@app/providers/authModeProvider'
import { useIonRouter } from '@ionic/react'
import { ROUTES } from '@shared/constants/routes'
import { getAuthCallbackUrl, isNativeAuthPlatform } from '@shared/lib/authRedirect'
import { getKeycloak } from '@app/providers/kcProvider'
import { clearLoginSessionCache } from '@shared/lib/authSessionCleanup'
import { useQueryClient } from '@tanstack/react-query'
import { Browser } from '@capacitor/browser'

const redirectToKeycloakLogout = async (): Promise<void> => {
	const logoutUrl = getKeycloak().createLogoutUrl({
		redirectUri: getAuthCallbackUrl(ROUTES.overall.hello),
	})

	if (isNativeAuthPlatform()) {
		await Browser.open({ url: logoutUrl })
		return
	}

	window.location.assign(logoutUrl)
}

const KeycloakLogout = () => {
	const nav = useIonRouter()
	const queryClient = useQueryClient()

	useEffect(() => {
		void (async () => {
			await clearLoginSessionCache(queryClient)
			try {
				await redirectToKeycloakLogout()
			} catch {
				nav.push(ROUTES.overall.hello)
			}
		})()
	}, [nav, queryClient])

	return <div></div>
}

const TokenLogout = () => {
	const { logout } = useAuthMode()
	const nav = useIonRouter()
	const queryClient = useQueryClient()

	useEffect(() => {
		void (async () => {
			await Promise.all([
				logout(),
				clearLoginSessionCache(queryClient, { clearAuthTokens: false }),
			])
			try {
				await redirectToKeycloakLogout()
			} catch {
				nav.push(ROUTES.overall.hello)
			}
		})()
	}, [logout, nav, queryClient])

	return <div></div>
}

export const LogoutPage = () => {
	const { mode } = useAuthMode()
	return mode === 'token' ? <TokenLogout /> : <KeycloakLogout />
}
